/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ParameterBaseWithSchema extends models.ParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ParameterBaseWithSchema");
    }

    getFixupPrototypeFunction() { return ParameterBaseWithSchema.fixupPrototype; }

    static newInstance(model: Partial<ParameterBaseWithSchema>): ParameterBaseWithSchema {
        let obj = Object.assign(new ParameterBaseWithSchema(), model);
        ParameterBaseWithSchema.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ParameterBaseWithSchema>): ParameterBaseWithSchema {
        if (!model) return null;
        return ParameterBaseWithSchema.newInstance(<ParameterBaseWithSchema> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ParameterBaseWithSchema) {
        if (!obj) return;

        models.ParameterBaseWithSchema.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ParameterBaseWithSchema): boolean {
        if (models.ParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ParameterBaseWithSchema.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.values_schema) {
            models.ParameterBase.fixupPrototype(this.values_schema);
        }
    }

    values_schema: models.ParameterBase;

}
